type Props = {
    color: string;
};

export const HomeIcon = ({ color }: Props) => (
    <svg id="SVGRoot" width="100%" height="100%" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g>
            <rect fill={color} x="224" width="64" height="64" />
            <rect fill={color} x="192" y="32" width="128" height="32" />
            <rect fill={color} x="192" y="32" width="32" height="64" />
            <rect fill={color} x="192" y="160" width="32" height="96" />
            <rect fill={color} x="288" y="160" width="32" height="96" />
            <rect fill={color} x="64" y="160" width="32" height="64" />
            <rect fill={color} x="416" y="160" width="32" height="352" />
            <rect fill={color} x="96" y="128" width="32" height="64" />
            <rect fill={color} x="384" y="128" width="32" height="384" />
            <g>
                <rect fill={color} x="160" y="64" width="32" height="64" />
                <rect fill={color} x="320" y="64" width="32" height="64" />
                <rect fill={color} x="288" y="32" width="32" height="64" />
                <rect fill={color} x="32" y="192" width="32" height="64" />
                <rect fill={color} x="448" y="192" width="32" height="64" />
                <rect fill={color} x="128" y="96" width="32" height="64" />
                <rect fill={color} x="352" y="96" width="32" height="64" />
            </g>
            <rect fill={color} x="288" y="64" width="64" height="32" />
            <rect fill={color} x="384" y="160" width="64" height="352" />
            <rect fill={color} x="64" y="160" width="64" height="352" />
            <g>
                <rect fill={color} x="64" y="160" width="64" height="32" />
                <rect fill={color} x="160" y="64" width="64" height="32" />
                <rect fill={color} x="128" y="96" width="64" height="32" />
                <rect fill={color} x="320" y="96" width="64" height="32" />
                <rect fill={color} x="96" y="128" width="64" height="32" />
                <rect fill={color} x="352" y="128" width="64" height="32" />
            </g>
            <rect fill={color} x="416" y="192" width="64" height="64" />
            <rect fill={color} x="32" y="192" width="64" height="64" />
            <g>
                <rect fill={color} x="192" y="160" width="128" height="32" />
                <rect fill={color} x="192" y="224" width="128" height="32" />
                <rect fill={color} x="192" y="288" width="128" height="32" />
            </g>
            <rect fill={color} x="192" y="288" width="32" height="224" />
            <rect fill={color} x="288" y="288" width="32" height="224" />
        </g>
    </svg>
);
